import { QueryFunction } from '@tanstack/react-query';
import {
  ExtractorConfiguration,
  ExtractorConfigurationResponse,
} from 'src/types/configurations';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';

const getExtractorConfiguration: QueryFunction<
  ExtractorConfiguration,
  ['/configurations/Extractor']
> = async () => {
  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<ExtractorConfigurationResponse>(
    '/configurations/Extractor',
    {
      method: 'GET',
    },
  );

  if (response.data) return response.data.configuration;
  throw new Error('Failed to fetch Extractor configuration');
};

export default getExtractorConfiguration;
